import { defineComponent as _defineComponent } from 'vue';
import { vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-0a8082fa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "input-phone-field input-group input-group-lg" };
const _hoisted_2 = { class: "input-wrapper flex-grow-1 position-relative" };
const _hoisted_3 = ["maxlength", "placeholder"];
import ValidateState from '@vue/components/form/ValidateState.vue';
import countryCodeList from '@vue/services/country-code';
import { $lang } from '@vue/services/utilities';
import TomSelect from 'tom-select';
import { useField } from 'vee-validate';
import { computed, onMounted, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PhoneField',
    emits: ['updateCountryCode', 'update'],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        onMounted(() => {
            initCountryCodeSelect();
        });
        // 選單的值是 ISO 代碼（如 'tw'）而不是撥號碼。
        // 撥號碼會重複（美/加同為 +1、哈/俄同為 +7），TomSelect 的 valueField 一旦重複，
        // 後出現的那筆會被 addOption 靜默丟棄，加拿大與俄羅斯就永遠選不到。
        const selectedCountry = ref('tw');
        // 對外（送 API、驗證）一律用撥號碼，維持原本的介面不變。
        const countryCode = computed(() => countryCodeList.find((item) => item.countryCode === selectedCountry.value)?.value ?? '+886');
        const field = useField(() => 'phone', computed(() => {
            if (countryCode.value === '+886') {
                return 'required|minLength:9|taiwanPhone';
            }
            else {
                return 'required';
            }
        }));
        const validateInputClass = ref();
        const validateTooltipClass = ref();
        watch(() => countryCode.value, (v) => {
            if (field.value.value?.length > 10) {
                field.setValue('');
            }
            emits('updateCountryCode', v);
        });
        watch(() => field.value.value, (v) => {
            const cleaned = (v ?? '').replace(/\D/g, '');
            if (v !== cleaned) {
                field.setValue(cleaned);
                return;
            }
            emits('update', cleaned);
        });
        function changeValidateState(v) {
            validateInputClass.value = v.inputClass;
            validateTooltipClass.value = v.tooltipClass;
        }
        function initCountryCodeSelect() {
            const optionRender = (data, escape) => `
        <div class="country-option d-flex gap-2 align-items-center">
          <span class="flag-icon flag-icon-${escape(data.countryCode)}"></span>
          <span class="country-name flex-grow-1">${escape(data.zhTW)}</span>
          <span class="country-dial small text-muted">${escape(data.value)}</span>
        </div>
      `;
            // 收合時只顯示國旗與號碼，避免把右邊的電話輸入框擠掉。
            const itemRender = (data, escape) => `
        <div class="d-flex gap-2">
          <span class="flag-icon flag-icon-${escape(data.countryCode)}"></span>
          <span class="small">${escape(data.value)}</span>
        </div>
      `;
            new TomSelect('#country-code', {
                // 跟著清單長度走 = 全部顯示。舊版寫死 95 剛好等於當時的清單長度，
                // 清單一長就會有國家被靜默截掉，沒有錯誤訊息也沒有「還有更多」提示。
                maxOptions: countryCodeList.length,
                valueField: 'countryCode',
                labelField: 'zhTW',
                // 中文名、英文名、撥號碼、ISO 代碼都可以搜，外國客打 "Netherlands" 或 "31" 都找得到。
                searchField: ['zhTW', 'enUS', 'value', 'countryCode'],
                // 必須從清單挑選，不接受自行輸入的字串當國別。
                create: false,
                allowEmptyOption: false,
                options: countryCodeList,
                items: ['tw'],
                wrapperClass: 'phone-country-select',
                render: {
                    option: optionRender,
                    item: itemRender,
                    no_results: () => '<div class="no-results">查無此國家</div>',
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedCountry).value = $event)),
                    id: "country-code"
                }, null, 512), [
                    [_vModelSelect, selectedCountry.value]
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        id: "input-phone",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(field).value.value) = $event)),
                        type: "tel",
                        class: _normalizeClass(["form-control form-control-lg", validateInputClass.value]),
                        name: "phone",
                        pattern: "\\d*",
                        maxlength: countryCode.value === `+886` ? 10 : '',
                        placeholder: _unref($lang)('app.reservation.form.placeholder.phone'),
                        onInput: _cache[2] || (_cache[2] = ($event) => (_unref(field).value.value = _unref(field).value.value.replace(/\D/g, '')))
                    }, null, 42, _hoisted_3), [
                        [_vModelText, _unref(field).value.value]
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(validateTooltipClass.value)
                    }, _toDisplayString(_unref(field).errorMessage), 3),
                    _createVNode(ValidateState, {
                        field: _unref(field),
                        onValidateState: changeValidateState
                    }, null, 8, ["field"])
                ])
            ]));
        };
    }
});
